

export const environment = {
  production: false,
  

 
   API_URL: "https://api-dev-reign.approd.ca/api/v1/", 
 









  


  
};
